import React, { useState, useEffect, Children, cloneElement } from 'react';
import { useInView } from 'react-intersection-observer';

interface ILazyLoadableProps {
  shouldLoad?: boolean;
}

interface IOffersListLazyWrapperProps {
  children: React.ReactElement<ILazyLoadableProps>;
  // Необязательно: можно добавить пропсы для настройки IntersectionObserver, например threshold, rootMargin и т.д.
  // threshold?: number;
  // rootMargin?: string;
}

export const OffersListLazyWrapper: React.FC<IOffersListLazyWrapperProps> = ({
  children /*, threshold = 0, rootMargin = '0px' */,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0, // Значение по умолчанию для threshold
    triggerOnce: true, // Загружать только один раз
    // rootMargin,
  });

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);

  // Ожидаем только одного потомка (OffersList), но делаем проверку на всякий случай
  const child = Children.only(children);

  // Клонируем потомка (OffersList) и передаём ему проп shouldLoad
  // ref вешаем на внешний div
  return <div ref={ref}>{cloneElement(child, { shouldLoad: isVisible })}</div>;
};
